import { type HTMLAttributes, memo } from 'react';
import { Formik, useFormikContext } from 'formik';
import { type PanelDropPreview } from '../common/panel-grid';
import { PanelDropPreviewOverlay } from '../CustomPage.styled';
import { PanelItem } from './PanelItem';

interface PanelDropPreviewRowProps extends Omit<PanelDropPreview, 'rowIndex'> {
  readonly showPanelErrors: boolean;
}

const inertAttribute = { inert: '' } as unknown as HTMLAttributes<HTMLDivElement>;

const PanelDropPreviewRowComponent = ({ row, incomingPanelId, showPanelErrors }: PanelDropPreviewRowProps) => {
  const { values } = useFormikContext<Record<string, unknown>>();
  const panelCount = row.length;

  // any Formik write from a projected editor lands in this throwaway form, never the real one.
  return (
    <Formik enableReinitialize initialValues={values} onSubmit={() => undefined}>
      <PanelDropPreviewOverlay {...inertAttribute} aria-hidden="true" data-testid="panel-drop-preview-row">
        {row.map((panel, panelIndex) => (
          <PanelItem
            key={panel.id}
            panel={panel}
            panelCount={panelCount}
            rowIndex={0}
            panelIndex={panelIndex}
            showPanelErrors={showPanelErrors}
            isDropPreview
            isDropPreviewIncoming={panel.id === incomingPanelId}
          />
        ))}
      </PanelDropPreviewOverlay>
    </Formik>
  );
};

export const PanelDropPreviewRow = memo(PanelDropPreviewRowComponent);
